import { queryBuilder } from '~/api/queryBuilder';

export const deleteUser = async (userId: number): Promise<void> => {
  const { data } = await queryBuilder('DELETE', `admin/users/${userId}`);
  return data;
};
